// extracted by css-extract-rspack-plugin
export default {"menuLink":"menuLink__pL_CZ","menuLink_active":"menuLink_active__ytFAs","theme_info":"theme_info__ZlKJm","questionLink":"questionLink__Bq42V"};